<template>
  <mdb-container class="gp-has-header">
      <mdb-card class="mb-4">
        <mdb-card-body>
          {{topMessage}}
        </mdb-card-body>
      </mdb-card>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import download from "js-file-download";

import {mdbBtn, mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader, mdbContainer, mdbIcon} from 'mdbvue';

export default {
  name: "file-downloader",
  display: "File",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
  },

  async mounted() {
    this.$store.dispatch("setExecuting", true)

    let downloadInfo = await api.getGroupFileLink(this.$route.params.id, this.$route.params.accessCode)
    if (!downloadInfo) {
      this.$store.dispatch("setExecuting", false)
      this.$notify.error({message: "File unavailable", timeOut: 4000})
      return
    }
    console.log("Downloading ", downloadInfo.url)
    const response = await fetch(downloadInfo.url)
    const blob = await response.blob()
    download(blob, downloadInfo.fileName)
    this.topMessage = "Your file should have downloaded automatically. If not, please check your browser permissions."
    this.$store.dispatch("setExecuting", false)

  },
  data() {
    return {
      topMessage: "Downloading....",
    };
  },

};

</script>
